export default 'dashboard';
